// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"3093":"e6a18dfcfb3424cafd0f","3180":"b4f5a4e18383d9585917","9277":"969b3e198271105ecce2"}[chunkId] + ".css";
};